module.exports = __webpack_public_path__ + "img/share2.78398107.svg";